import { Pipe, PipeTransform } from '@angular/core';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { UserPlanning } from 'src/app/classes/user-planning';
import { Utils } from 'src/app/utils.class';

@Pipe({
    name: 'employeeIsNight',
    standalone: false,
})
export class EmployeeIsNightPipe implements PipeTransform {
    transform(projectDayUser?: {
        type: 'userPlanning' | 'planning' | 'project';
        userPlanning?: UserPlanning[];
        planningHas?: PlanningHasEntity[];
    }): boolean {
        return !!(
            projectDayUser?.userPlanning?.some(
                ({ begindate, enddate, deleted_at }) => !deleted_at && Utils.isNight(begindate, enddate)
            ) ||
            projectDayUser?.planningHas?.some(
                ({ begindate, enddate, deleted_at }) => !deleted_at && Utils.isNight(begindate, enddate)
            )
        );
    }
}
